"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSplitButtonSlots = exports.default = exports.SplitButton = void 0;
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _utils = require("../utils");
var _splitButtonClasses = _interopRequireWildcard(require("./splitButtonClasses"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const getSplitButtonSlots = ownerState => {
  const {
    fullWidth,
    color,
    size,
    disabled,
    loading,
    edge
  } = ownerState;
  return {
    root: ['root', `color${(0, _utils.capitalize)(color)}`, `size${(0, _utils.capitalize)(size)}`, `edge${(0, _utils.capitalize)(edge)}`, fullWidth && 'fullWidth', disabled && 'disabled', loading && 'loading'],
    button: ['button'],
    content: ['content']
  };
};
exports.getSplitButtonSlots = getSplitButtonSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getSplitButtonSlots(ownerState);
  return (0, _base.unstable_composeClasses)(slots, _splitButtonClasses.getSplitButtonUtilityClass, classes);
};
const SplitButtonRoot = (0, _material.styled)('span', {
  name: 'MuiOriSplitButton',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.root, styles[`color${(0, _utils.capitalize)(ownerState.color)}`], styles[`size${(0, _utils.capitalize)(ownerState.size)}`], styles[`edge${(0, _utils.capitalize)(ownerState.edge)}`], ownerState.disabled && styles.disabled, ownerState.loading && styles.loading, ownerState.fullWidth && styles.fullWidth]
})(({
  theme,
  ownerState
}) => ({
  display: 'inline-grid',
  gridTemplateAreas: '"content button"',
  border: '1px solid',
  borderRadius: 25,
  gridTemplateColumns: `${ownerState.contentWidth} 1fr`,
  borderColor: theme.palette[ownerState.color].main,
  minWidth: 'min(320px, 100%)',
  overflow: 'hidden',
  ...(ownerState.color === 'primary' && {
    borderColor: theme.palette.default.dark
  }),
  ...(ownerState.size === 'small' && {
    minWidth: 'min(280px, 100%)'
  }),
  ...(ownerState.edge === 'start' && {
    gridTemplateAreas: '"button content"',
    gridTemplateColumns: `1fr ${ownerState.contentWidth}`
  }),
  ...(ownerState.fullWidth && {
    width: '100%'
  }),
  ...(ownerState.loading && {
    borderColor: theme.palette.grey[200]
  }),
  [`&.${_splitButtonClasses.default.disabled}`]: {
    borderColor: theme.palette.grey[200],
    color: theme.palette.grey.A400,
    background: theme.palette.grey[200],
    pointerEvents: 'none'
  }
}));
const Button = (0, _material.styled)(_material.ButtonBase, {
  name: 'MuiOriSplitButton',
  slot: 'Button',
  overridesResolver: (_, styles) => [styles.button]
})(({
  theme,
  ownerState
}) => ({
  backgroundColor: theme.palette[ownerState.color].main,
  color: theme.palette[ownerState.color].contrastText,
  gridArea: 'button',
  alignSelf: 'stretch',
  justifySelf: 'stretch',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  padding: '11px 22px',
  ...theme.typography.button,
  ...(ownerState.size === 'small' && {
    padding: '8px 19px',
    fontSize: '1.3rem',
    lineHeight: 1.75
  }),
  '&:hover': {
    backgroundColor: theme.palette[ownerState.color].dark,
    '@media (hover: none)': {
      backgroundColor: theme.palette[ownerState.color].main
    }
  },
  ...(ownerState.color === 'primary' && {
    background: theme.palette.default.dark,
    color: theme.palette.default.contrastText,
    '&:hover': {
      background: theme.palette.grey.A700,
      '@media (hover: none)': {
        background: theme.palette.default.dark
      }
    },
    [`&.${_base.buttonClasses.disabled}`]: {
      background: theme.palette.grey[200]
    }
  }),
  ...((ownerState.loading || ownerState.disabled) && {
    background: theme.palette.grey[200],
    color: theme.palette.grey.A400
  })
}));
const Content = (0, _material.styled)('div', {
  name: 'MuiOriSplitButton',
  slot: 'Content',
  skipSx: true,
  overridesResolver: (_, styles) => [styles.content]
})(({
  ownerState
}) => ({
  gridArea: 'content',
  alignSelf: 'center',
  display: 'flex',
  alignItems: 'center',
  ...(ownerState.edge === 'end' && {
    borderRadius: '25px 0 0 25px'
  }),
  ...(ownerState.edge === 'start' && {
    borderRadius: '0 25px 25px 0'
  })
}));
const LoadingIndicator = /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.CircularProgress, {
  color: "inherit",
  size: "1.8rem"
});
const SplitButton = exports.SplitButton = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _material.useThemeProps)({
    props: inProps,
    name: 'MuiOriSplitButton'
  });
  const {
    className,
    buttonContent,
    ButtonComponent = Button,
    ButtonProps,
    onClick,
    loadingIndicator = LoadingIndicator,
    disabled = false,
    loading = false,
    edge = 'end',
    color = 'primary',
    size = 'medium',
    contentWidth = 'auto',
    component = 'span',
    fullWidth,
    children,
    ...rest
  } = props;
  const ownerState = {
    ...props,
    edge,
    color,
    disabled,
    loading,
    size,
    contentWidth,
    fullWidth
  };
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(SplitButtonRoot, {
    ref: ref,
    as: component,
    ownerState: ownerState,
    className: (0, _clsx.default)(classes.root, className),
    ...rest,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Content, {
      ownerState: ownerState,
      className: classes.content,
      children: children
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonComponent, {
      disabled: disabled || loading,
      ownerState: ownerState,
      className: classes.button,
      onClick: onClick,
      ...ButtonProps,
      children: loading ? loadingIndicator : buttonContent
    })]
  });
});
var _default = exports.default = SplitButton;
